import { Injectable } from '@angular/core';
import { Intercom } from '@supy-io/ngx-intercom';
import { Cargochief } from '../cargochief/cargochief.service';
import { C4UserDTO, IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import { environment } from '@environment/environment';
import { UtilService } from '../util/util.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class IntercomService {
	// Live unread-message count for the custom nav launcher badge.
	readonly unreadCount$ = new BehaviorSubject<number>(0);

	constructor(
		public intercom: Intercom,
		private cargoChief: Cargochief,
		private utilService: UtilService
	) {}

	boot() {
		const user: C4UserDTO = this.cargoChief.getUser();
		if (
			IS_NOT_NULL_OR_UNDEFINED(user) &&
			(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper())
		) {
			const intercomPayload = {
				app_id: environment.INTERCOM_APP_ID,
				user_id: user.id.toString(),
				name: `${user.firstName} ${user.lastName}`,
				email: user.email,
				phone: user.phoneNumber,
				company: {
					company_id: user.accountId,
					name: user.businessName,
				},
			};
			this.intercom.boot(intercomPayload);
			this.intercom.onUnreadCountChange((count?: number) => this.unreadCount$.next(count ?? 0));
		}
	}

	hideWidget() {
		this.intercom.update({
			hide_default_launcher: true,
		});
	}

	showWidget() {
		this.intercom.update({
			hide_default_launcher: false,
		});
	}

	shutdown() {
		this.intercom.shutdown();
		this.unreadCount$.next(0);
	}

	// Boot Intercom but suppress its floating launcher; the header renders a custom nav launcher instead.
	bootAndShow() {
		this.boot();
		this.hideWidget();
	}

	// Open the Intercom messenger from the custom nav launcher.
	openMessenger() {
		this.intercom.show();
	}
}
